import { render, staticRenderFns } from "./bg-data-item.vue?vue&type=template&id=140d4bd3&scoped=true"
import script from "./bg-data-item.vue?vue&type=script&lang=js"
export * from "./bg-data-item.vue?vue&type=script&lang=js"
import style0 from "./bg-data-item.vue?vue&type=style&index=0&id=140d4bd3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140d4bd3",
  null
  
)

export default component.exports